import { devices } from '@helpers/utils.js';
import { ImageAsBackgroundSaveBlock } from '../index';

const BackgroundTypeImageAndColorSave = ({
  backgroundImageAndColorOptions,
  blockId,
  defaultBlockCssClass,
  printBackgroundStyles,
}) => {
  const classNames = 'bg-img-color';
  const imageAsBackgroundOptions = backgroundImageAndColorOptions;

  return (
    <>
      <style>
        {devices.map((device) => {
          const deviceType = device.type;
          const backgroundColorSettings =
            backgroundImageAndColorOptions[deviceType].settings;
          const backgroundColor = backgroundColorSettings.backgroundColor
            ? backgroundColorSettings.backgroundColor
            : '';
          if (!backgroundColor) return '';
          let cssCode = '';
          const printQuery = printBackgroundStyles
            ? `, print and (max-width: ${backgroundImageAndColorOptions[deviceType].breakpoint}px)`
            : ``;
          if (deviceType === 'desktop') {
            cssCode += `.${defaultBlockCssClass}.${defaultBlockCssClass}-${blockId} { background-color: ${backgroundColor};} `;
          } else {
            cssCode += `@media only screen and (max-width: ${backgroundImageAndColorOptions[deviceType].breakpoint}px)${printQuery} {
                .${defaultBlockCssClass}.${defaultBlockCssClass}-${blockId} { 
                        background-color: ${backgroundColor}; 
                      }
                    }`;
          }
          return cssCode;
        })}
      </style>
      <ImageAsBackgroundSaveBlock
        {...{ classNames, devices, imageAsBackgroundOptions }}
      />
    </>
  );
};

export default BackgroundTypeImageAndColorSave;
